import { cn } from '@/util/cn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-muted-foreground/20 animate-pulse rounded', className)}
      {...props}
    />
  );
}

export { Skeleton };
